import { Button, Stack } from '@mui/material'
import React from 'react'

import { StyledRouterLink } from 'components/common/StyledRouterLink'
import Icon from 'components/Icon'
import { DeleteStatusCheck } from 'components/status-checks/list/DeleteStatusCheck'
import { getStatusChecksUrls } from 'components/status-checks/status-checks-urls-utils'
import toast from 'lib/toast'
import { useGetStatusChecks } from 'queries/status-checks/use-get-status-checks'
import { type StatusCheck } from 'types/api/status-checks/status-check'
import { handleDataFetchOnChange } from 'utils/handle-data-fetch-on-change'

export const StatusCheckListActionCell: React.FC<{
  statusCheck: StatusCheck
}> = ({ statusCheck }) => {
  const statusChecksUrls = getStatusChecksUrls()
  const { refetch: reFetchStatusChecks } = useGetStatusChecks({
    enabled: false
  })

  return (
    <Stack direction="row" sx={{ alignItems: 'center', columnGap: 2 }}>
      <Button
        component={StyledRouterLink}
        data-test-edit-status-check={statusCheck.identifier}
        data-track-action="edit-status-check"
        data-track-category="status-checks" // TODO track anything different if it's PNI?
        data-track-on="click"
        size="small"
        startIcon={<Icon icon="edit" />}
        to={statusChecksUrls.edit(statusCheck.identifier)}
        variant="contained"
      >
        Edit
      </Button>
      <Button
        component={StyledRouterLink}
        data-test-clone-status-check={statusCheck.identifier}
        data-track-action="clone-status-check"
        data-track-category="status-checks" // TODO track anything different if it's PNI?
        data-track-on="click"
        size="small"
        startIcon={<Icon icon="clone" />}
        state={{
          statusCheck: { ...statusCheck, identifier: null }
        }}
        to={statusChecksUrls.new()}
        variant="contained"
      >
        Clone
      </Button>
      <DeleteStatusCheck
        statusCheck={statusCheck}
        onChanged={async () => {
          toast({
            type: 'success',
            text: `Successfully deleted Health Check ${statusCheck.name}`
          })
          await handleDataFetchOnChange(reFetchStatusChecks)
        }}
      />
    </Stack>
  )
}
